import script from "./mobile-invoiceview.vue?vue&type=script&setup=true&lang=js"
export * from "./mobile-invoiceview.vue?vue&type=script&setup=true&lang=js"

import "./mobile-invoiceview.vue?vue&type=style&index=0&id=c3a4199c&lang=css"

const __exports__ = script;

export default __exports__